import "./style.scss";

export const Spinner = () => <div className="rcw-spinner-border" />;
